import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-region-indicator/jb-region-indicator.css.ts
var jb_region_indicator_css_default = i`div{align-items:center;cursor:pointer;display:var(--display, flex);font-size:0;position:relative;z-index:10}div::after{display:none;right:var(--after-right, 100%);top:35px}@media(min-width: 1281px){div::after{display:block}}div:hover::after{right:30px}@supports(-webkit-appearance: none){div:hover::after{right:13%}}@media all and (-ms-high-contrast: none){div:hover::after{right:13%}}::slotted(jb-region-indicator-item:not(:last-of-type)){--dot-display: block;--padding-right: 20px}`;

export {
  jb_region_indicator_css_default
};
